export class Email {
    BCC: string;
    CC: string;
    From: string;
    Subject: string;
    To: string;
}

export class GarantieTarifee {
    Affichage: string;
    CodeDivision: string;
    FormuleGroupee: string;
    FraisAcquisition: string;
    FraisAdministration: string;
    FraisFractionnement: string;
    FraisGestion: string;
    Libelle: string;
    Ordre: string;
    PrimeBrute: string;
    PrimeNette: string;
    Produit: string;
    Tarifee: string;
    Taxes: string;
    Validite: string;
    RegrDivision: string;
}

export class GarantiesBatiment {
    GarantieTarifee: GarantieTarifee[];
}

export class GarantiesContenu {
    GarantieTarifee: GarantieTarifee[];
}

export class GarantiesContrat {
    GarantieTarifee: GarantieTarifee[];
}

export class CreerDossierIncendie {
    AircoChauffageSolPompeAChaleur: boolean;
    AlarmeAgreeIncert: boolean;
    Ascenceur: boolean;
    BatiementClasse: boolean = false;
    Branche: string;
    CapitalBatiment: string;
    CapitalContenu: string;
    CodeLocalite: string;
    CodePays: string;
    CodePostal: string;
    CodeTypeContiguite: string;
    CommuneLibelle: string;
    CritAcceoBatimentJamaisAssure: boolean = false;
    // CritAccepSinistreDansLesTroisDerniere: boolean = false;
    DateEffect: string;
    DateEntreeService: string;
    DateIndex: string;
    DatePropositoin: string;
    DateTarif: string;
    Email: Email;
    EtatBatiment: string;
    GarageInerieur: boolean;
    GarantiesBatiment: GarantiesBatiment;
    GarantiesContenu: GarantiesContenu;
    GarantiesContrat: GarantiesContrat;
    Grenier: boolean = false;
    Langue: string;
    LibelleRueID: string;
    MethodEvaluationBatiement: string;
    // MethodEvaluationContenu: string;
    NatureAutruiAbandonRecours: string;
    NaturePreneur: string;
    NaturePreneurContenu: string;
    NbrAbrisJardinCarPort: string;
    NbrAnnexes: string;
    // NbrCaves: number;
    NbrFacade: string;
    NbrGaragesHorsBatiment: number;
    NbrGaragesDansBatiment: boolean;
    NbrPiecesAppartement: number;
    NbrPiecesRDCEtage: number;
    NoClient: number;
    NoIntermediaire: string;
    NoProducteur: string;
    NoProspectCRM: string;
    NoSimulation: string;
    NumeroBoite: string;
    NumeroImmeuble: string;
    PanneauxPhotovoltaiques: boolean;
    Periodicite: string;
    PiecesAUsagePrfeossionnel: boolean;
    PiscineExterieure: boolean;
    PiscineInterieure: boolean;
    ResidencePrincipale: boolean;
    Rue: string;
    SolEnParquetPierreNaturelle: boolean;
    SousSol: boolean;
    TarifBuilding: boolean;
    ToitureArdoisePailleChaume: boolean;
    TypeBatiment: string;
    TypeConstruction: string;
    TypeContenu: string;
    TypeSituation: string;
    UsageBatiment: string;
    LangueClient: string;
    MachineName: string;
    NomPage: string;
    PageId: string;
    Utilisateur: string;
    '_xmlns:ns0': string;
    __prefix: string;
    critAccepContratPrecedemmentResilie: boolean;
    critAccepBatimentJamaisAssure: boolean;
    critAccepBatimentInhabite: boolean;
    critAccepBatimentClasse: boolean;
    critAccepRisqueCaravane: boolean;
    CritAccepPreneurEnFaillite: boolean;
    // DescriptionSpecifique: string;
    DemandeSpecifique: string;
    CritAccepSinistreDansLesTroisDernieresAnnees: boolean;
    AnnexeGE50: boolean;
    // MethodeEvaluationBatiment: string;
    MethodEvaluationContenu: string;
    emailClient: string;
    // EtatSituation: string;

    CapitalBatimentEvalue: string;
    CapitalContenuEvalue: string;
    // NbrAppartment: number;
    // critAcceptvide: string;
    origine: string;
    OrigineCanalDistribution: string;
    TypeVente: string;
    TypeLocation: string;
}

export class DocumentModel {
    CreerDossierIncendie: CreerDossierIncendie;
}

export class DocumentResponseModel {
    creationReussie: string;
    noSimulation2: string;
    noDossier: string;
    noSituation: string;
    documentPDF: any;
}

    export class Documents{
        SimulationToken: string;
        FniceNo : string;
        SignedDocFileAsBase64 : string;
        IdDocFileAsBase64 : string;
        IdDocExtension:string;
        SignedDocFileName:string;
        IdDocFileName:string;
        Email:string;
        Firstname: string;
        Lastname:string;
        Language:string;
    }




